export default __webpack_public_path__ + "static/media/288.21537fc8.jpg";